export enum TransactionCategorizationType {
  EXPENSE = 'EXPENSE',
  INCOME = 'INCOME',
}
